import BaseComponent from 'scripts/BaseComponent.js';
import axios from 'axios';
import Cart from '../../cart/cart';

export default class ProductQuickAddCard extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      link: '.js-productCardLink',
      imageContainer: '.js-productCardImage',
      selectedColor: '.js-productCardColor',
      swatchBtn: '.js-productCardSwatch',
      priceContainer: '.js-priceContainer',
      swatchesContainer: '.js-productCardSwatches',
      hoverImg: '.js-productCardHoverImage',
      quickAddBtn: '.js-quickAdd',
    };

    this.dom = {
      $component: component,
      $links: this.$getAll(this.refs.link),
      $imageContainer: this.$get(this.refs.imageContainer),
      $selectedColor: this.$get(this.refs.selectedColor),
      $swatchBtns: this.$getAll(this.refs.swatchBtn),
      $priceContainer: this.$get(this.refs.priceContainer),
      $swatchesContainer: this.$get(this.refs.swatchesContainer),
      $hoverImg: this.$get(this.refs.hoverImg),
      $quickAddBtn: this.$get(this.refs.quickAddBtn),
    };

    this.state = {
      activeColor: null,
      activeColorClass: 'is-selected',
      soldOutClass: 'sold-out',
      observer: null,
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    const { asyncSwatches } = dom.$component.dataset;

    super.mount();

    if (asyncSwatches) {
      this.observe();
    } else {
      this.setSwatchListeners();
    }
  }

  observe() {
    const { dom, state } = this;

    state.observer = new IntersectionObserver(this.onIntersection.bind(this), {
      rootMargin: '250px',
    });
    state.observer.observe(dom.$component);
  }

  onIntersection([entry]) {
    const { state: { observer } } = this;

    if (entry.isIntersecting) {
      this.loadAsyncSwatches();
      observer.unobserve(entry.target);
    }
  }

  async loadAsyncSwatches() {
    const { dom } = this;
    const { handle, variantId } = dom.$component.dataset;

    try {
      const { data } = await axios.get(`/products/${handle}?variant=${variantId}&view=swatch-data`);
      const parser = new DOMParser();
      const page = parser.parseFromString(data, 'text/html');
      this.setCardSwatches(page);
      this.setHoverImage(page);
      dom.$swatchBtns = this.$getAll(this.refs.swatchBtn);
      this.setSwatchListeners();
    } catch (e) {
      console.log('error', e);
    }
  }

  setCardSwatches(html) {
    const { dom, refs } = this;
    const dataVariantTitle = html.querySelector(refs.selectedColor);
    const dataSwatches = html.querySelector(refs.swatchesContainer);
    if (dataVariantTitle) {
      dom.$selectedColor.innerHTML = dataVariantTitle.innerHTML;
    }
    if (dataSwatches) {
      dom.$swatchesContainer.innerHTML = dataSwatches.innerHTML;
    }
  }

  setHoverImage(html) {
    const { dom, refs } = this;
    const dataHoverImg = html.querySelector(refs.hoverImg);

    if (dataHoverImg) {
      dom.$hoverImg.innerHTML = dataHoverImg.innerHTML;
    }
  }

  setSwatchListeners() {
    const { dom } = this;

    this.setCurrentColor();
    this.setClickWithElement(dom.$swatchBtns, this.swatchClick);
    this.setClickWithElement(dom.$quickAddBtn, this.quickAdd);
  }

  setCurrentColor() {
    const { dom, state } = this;

    if (dom.$selectedColor) {
      state.activeColor = dom.$selectedColor.textContent.trim();
    }
  }

  swatchClick(swatch) {
    const { dom, state } = this;
    const {
      color,
      url,
      imageSrc,
      imageSrcsets,
      soldOut,
    } = swatch.dataset;

    if (state.activeColor === color) return;

    dom.$links.forEach((link) => link.setAttribute('href', url));
    dom.$selectedColor.textContent = color;
    this.setActiveImage(imageSrc, imageSrcsets);
    this.setActiveSwatch(swatch);
    this.setSoldOutState(soldOut ? soldOut === '1' : false);
    state.activeColor = color;
  }

  setActiveImage(imageSrc, imageSrcsets) {
    const { dom } = this;

    dom.$imageContainer.querySelector('img').src = imageSrc;
    imageSrcsets.split('|').forEach((srcsetString) => {
      const [media, srcset] = srcsetString.split('*');
      dom.$imageContainer.querySelector(`source[media="${media}"]`).srcset = srcset;
    });
  }

  setActiveSwatch(selectedSwatch) {
    const { state, refs } = this;
    const currentActiveSwatch = this.$get(`${refs.swatchBtn}[data-color="${state.activeColor}"]`);

    currentActiveSwatch.classList.remove(state.activeColorClass);
    selectedSwatch.classList.add(state.activeColorClass);
  }

  setSoldOutState(soldOut) {
    const { dom } = this;

    if (soldOut) {
      dom.$quickAddBtn.setAttribute('disabled', true);
    } else {
      dom.$quickAddBtn.removeAttribute('disabled');
    }
  }

  quickAdd() {
    const { dom } = this;
    const properties = {
      _mini_cart_upsell: true,
    };
    const [selectedSwatch] = Array.from(dom.$swatchBtns).filter((swatch) => swatch.classList.contains('is-selected'));

    if (!selectedSwatch) {
      const defaultVariant = dom.$component.getAttribute('data-variant-id');
      Cart.addItem(defaultVariant, properties, 1, false);
      return;
    }

    Cart.addItem(selectedSwatch.getAttribute('data-id'), properties, 1, false);
  }
}
